import { Form } from "antd";
import { useTranslation } from "react-i18next";
import { formatNumber } from "src/utility";
import { useTopupDetails } from "../context/TopupDetailsContext";
import { RechargeValues } from "../components/TopupSummary/RechargeConfirmation";

export function useRechargeSummary(): RechargeValues {
  const { t } = useTranslation();
  const { item } = useTopupDetails();
  const form = Form.useFormInstance();
  const getAmount = Form.useWatch("getAmount", form);
  const payAmount = Form.useWatch("payAmount", form);
  const payPoints = Form.useWatch("payPoints", form);

  const serviceValue = getAmount ?? 0;
  const serviceFees = payAmount && getAmount ? payAmount - getAmount : 0;
  const totalAmount = payAmount ?? 0;
  const points = payPoints ?? 0;
  const currency = item?.currency ?? t("Topup.currency");

  const matchedServiceCharge = item?.serviceChargeList?.find((sc) => getAmount >= sc.from && getAmount < sc.to);
  const serviceFeesDisplay = matchedServiceCharge?.percentage
    ? `${formatNumber(matchedServiceCharge.charge)}%`
    : `${formatNumber(serviceFees)} ${currency}`;

  return {
    serviceValue: String(formatNumber(serviceValue)),
    serviceFeesDisplay,
    totalAmount: String(formatNumber(totalAmount)),
    points: String(formatNumber(points)),
    currency,
  };
}
